
























import { computed, defineComponent } from '@vue/composition-api';
import Card from './Card.vue';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'FormBlock',
    components: { Card, Icon },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
        },
    },
    setup(props, { slots }) {
        const isEmpty = computed(() => !slots.default);

        return { isEmpty };
    },
});
